import React from 'react';
import { BodyText, BoldHeader1Text, Button, FlexRow, Header1Text, NavigationItem } from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import { prettyVendorStatus } from '../../types/order/title/eTitleSearchStatus';
import { IconType, RotatingIcon } from 'ui-toolkit';
import { getDaysAgoString } from '../../ui-toolkit/utilities/getDaysAgoString';
import { useHasFeatureFlag } from '../../selectors/useHasFeatureFlag';

interface IOrderPanelProps {
  prefix: string;
  backTo: string;
  fileNumber: string;
  createdAt?: string;
  readyToSend: boolean;
  status: string;
  onSendToSpruce: () => void;
  sendToSpruceFetchStatus: IFetchStatus;
}

export const OrderPanel: React.FC<IOrderPanelProps> = ({
  prefix,
  backTo,
  fileNumber,
  createdAt,
  status,
  readyToSend,
  onSendToSpruce,
  sendToSpruceFetchStatus,
}) => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  return (
    <FlexRow justifyContent={'space-between'} verticalAlign={'center'}>
      <FlexRow>
        <NavigationItem text={''} to={backTo}>
          <Header1Text>
            <FontAwesomeIcon icon={faChevronLeft} />
          </Header1Text>
        </NavigationItem>
        <BoldHeader1Text>{prefix}</BoldHeader1Text>
        <Header1Text>Order {fileNumber}</Header1Text>
      </FlexRow>
      <FlexRow>
        {sendToSpruceFetchStatus.fetching ? <RotatingIcon type={IconType.Loading} /> : null}
        {readyToSend ? (
          <Button intent={'primary'} onClick={() => onSendToSpruce()}>
            Send To {isZillowClosingEnabled ? 'Zillow Closing' : 'Spruce'}
          </Button>
        ) : (
          <Button intent={'primary'} disabled={true}>
            {prettyVendorStatus[status]} <FontAwesomeIcon icon={faEdit} />
          </Button>
        )}

        <BodyText>{createdAt ? `Created ${getDaysAgoString(createdAt)}` : null}</BodyText>
      </FlexRow>
    </FlexRow>
  );
};
